export const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';
export const DEFAULT_DATE_MASK = '__.__.____';
